export default {
      id: "appli_mobile-usage",
      viewBox: "0 0 57 56",
      url: "../dist/images/" + "sprite.svg#appli_mobile-usage",
      toString: function () {
        return this.url;
      }
    }